import { Door } from "../../data/models.interface"
import useLazyQuery from "../useLazyQuery"

export const useCreateDoorQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/doors`
	return useLazyQuery<Door, void>(url, "POST")
}
